import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import StandardDropdown from '../StandardDropdown';
import s from './FormDropdown.scss';
const FormDropdown = (_param)=>{
    var { className, menuClassName } = _param, props = _object_without_properties(_param, [
        "className",
        "menuClassName"
    ]);
    return /*#__PURE__*/ React.createElement(StandardDropdown, _object_spread({
        role: "listbox",
        className: c(s['dropdown'], className),
        menuClassName: c(s['dropdown-menu'], menuClassName),
        toggleClassName: s['dropdown-toggle'],
        openClassName: s['dropdown-selected'],
        placeholderClassName: s['dropdown-placeholder'],
        usePortal: true,
        menuScrollable: true
    }, props));
};
FormDropdown.displayName = 'FormDropdown';
export default FormDropdown;

//# sourceMappingURL=FormDropdown.js.map